/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { VhatsAppBaseService } from '../vhats-app-base-service';
import { hatsAppApiConfiguration } from '../hats-app-api-configuration';
import { hatsAppStrictHttpResponse } from '../hats-app-strict-http-response';

import { apiTwilioWhatsappIncomingPost } from '../fn/twilio/api-twilio-whatsapp-incoming-post';
import { ApiTwilioWhatsappIncomingPost$Params } from '../fn/twilio/api-twilio-whatsapp-incoming-post';
import { apiTwilioWhatsappStatuscallbackPost } from '../fn/twilio/api-twilio-whatsapp-statuscallback-post';
import { ApiTwilioWhatsappStatuscallbackPost$Params } from '../fn/twilio/api-twilio-whatsapp-statuscallback-post';


/**
 * Controller for Twilio WhatsApp flow. Incoming webhook does not require app auth; it is validated via Twilio signature.
 */
@Injectable({ providedIn: 'root' })
export class hatsAppTwilioService extends VhatsAppBaseService {
  constructor(config: hatsAppApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTwilioWhatsappIncomingPost()` */
  static readonly ApiTwilioWhatsappIncomingPostPath = '/api/twilio/whatsapp/incoming';

  /**
   * Receives incoming WhatsApp messages from Twilio. Dispatches command:value to handlers or runs generic bot (e.g. OptIn trigger-word flow).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTwilioWhatsappIncomingPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTwilioWhatsappIncomingPost$Response(params?: ApiTwilioWhatsappIncomingPost$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<void>> {
    const obs = apiTwilioWhatsappIncomingPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Receives incoming WhatsApp messages from Twilio. Dispatches command:value to handlers or runs generic bot (e.g. OptIn trigger-word flow).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTwilioWhatsappIncomingPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTwilioWhatsappIncomingPost(params?: ApiTwilioWhatsappIncomingPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTwilioWhatsappIncomingPost$Response(params, context);
    return resp.pipe(
      map((r: hatsAppStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiTwilioWhatsappStatuscallbackPost()` */
  static readonly ApiTwilioWhatsappStatuscallbackPostPath = '/api/twilio/whatsapp/statuscallback';

  /**
   * Twilio status callback: updates message delivery status and sends next queued message when a message is delivered.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTwilioWhatsappStatuscallbackPost()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiTwilioWhatsappStatuscallbackPost$Response(params?: ApiTwilioWhatsappStatuscallbackPost$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<void>> {
    const obs = apiTwilioWhatsappStatuscallbackPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Twilio status callback: updates message delivery status and sends next queued message when a message is delivered.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTwilioWhatsappStatuscallbackPost$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  apiTwilioWhatsappStatuscallbackPost(params?: ApiTwilioWhatsappStatuscallbackPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.apiTwilioWhatsappStatuscallbackPost$Response(params, context);
    return resp.pipe(
      map((r: hatsAppStrictHttpResponse<void>): void => r.body)
    );
  }

}
